import React, { useState, useEffect } from "react";
import { FullWidthWrapper, Modal } from "../../../Components/Wrappers";
import { StudioAuthNavActions } from "../../../Components/Nav";
import { Flex, Box } from "rebass/styled-components";
import { MainRail } from "../Components/MainRail";
import styled from "styled-components";
import { useMediaQuery } from "../../../Hooks/useMediaQuery";
import theme from "../../../../theme/themeThree";
import StudioModals from "./Components/Modals";
import "./fonts.css";
import { FacetPanel } from "../Components/FacetPanel";
import { EStudioTabView, TStudioProps } from "../../../@types";
import { CardDetail } from "../Components/CardDetail";
import { CardClips } from "../Components/CardClips";
import { EnabledCardsPanel } from "./Components/EnabledCards";
import CloseButton from "../../../../components/atoms/form/button/close";
import ShareCardButton from "../../../../components/atoms/form/button/shareCard";
import { Divider } from "../../../Components/Divider";
import { ShareModalContents } from "./Components/Share";
import { ModalClickHandler } from "./Components/ModalClickHandler";
import { StudioSession } from "../../../State/studioSession";
import { useRecoilState } from "recoil";
import { useIsMobileApp } from "../../../Hooks/useIsMobileApp";
import { RemixHeader } from "../RemixView/Components/Pinned";

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export function StudioView({
  modal,
  setModal,
  clear,
  query,
  onQuery,
  handleCardClick,
  handleCardToggle,
  facetLoading,
  cardsData,
  singleCardData,
  cardClips,
  creatorCardModal,
  setCreatorCardModal,
  allstarUser,
  logout,
  getFreshProfile,
  banner,
  pageNav,
  mutateFollowers,
  remixData,
  ownerInfo,
  clearEnabledCards,
  handleToggleAll,
  postRemix,
}: TStudioProps) {
  // Check for mobile:
  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints[1]})`);
  const { isMobileApp } = useIsMobileApp();
  const [isSideMenuVisible, toggleSideMenuVisible] = useState(
    !(isMobile || isMobileApp),
  );
  const [shareModal, setShareModal] = useState(false);
  const [view, setView] = useState("Marketplace");
  const [muted, setMuted] = useState(true);
  const [studioSession, setStudioSession] = useRecoilState(StudioSession);
  const [isEnabledVisible, setIsEnabledVisable] = useState(
    studioSession.isRemixSession && !isMobileApp,
  );

  const switchViewTab = (view: EStudioTabView) => {
    scrollToTop();
    setView(view);
    if (isMobileApp) {
      setIsEnabledVisable(false);
      toggleSideMenuVisible(false);
    }
    if (!studioSession.isRemixSession) {
      const isMyCards = view === EStudioTabView.Collections;
      onQuery(isMyCards, "myCards", "Enabled Cards");
    }
  };

  const handleModalClose = () => {
    setCreatorCardModal(false);
    setShareModal(false);
    window.history.replaceState(null, "", pageNav);
  };

  // useEffect(() => {}, [cardsData]);
  useEffect(() => {
    const shouldClearStudioEnabled =
      studioSession.confirmedClear &&
      allstarUser.loggedIn &&
      !studioSession.isRemixSession;

    if (shouldClearStudioEnabled) {
      setStudioSession({
        ...studioSession,
        confirmedClear: false,
        userActivated: [],
      });
      setModal({ type: "" });
      clearEnabledCards();
    }
  }, [studioSession.confirmedClear]); //eslint-disable-line

  useEffect(() => {
    window.rudderanalytics.page("Studio", "Studio View");
  }, []);

  const openFacetMenu = () => {
    if (isMobileApp) {
      setIsEnabledVisable(false);
    }
    toggleSideMenuVisible(!isSideMenuVisible);
  };
  const openEnabledCards = () => {
    if (isMobileApp) {
      toggleSideMenuVisible(false);
    }
    setIsEnabledVisable(!isEnabledVisible);
  };
  const onQueryIntercept = (
    checked: boolean,
    indentifier: string,
    label: string,
    isCardClick?: boolean,
  ) => {
    if (isMobileApp) {
      toggleSideMenuVisible(false);
    }
    setView("Marketplace");
    onQuery(checked, indentifier, label, isCardClick);
  };

  return (
    <>
      <StudioModals
        modal={modal}
        toggleModal={setModal}
        getFreshProfile={getFreshProfile}
        allstarUser={allstarUser}
        handleCardToggle={handleCardToggle}
      />

      <StyledModal
        px={[0, 0, 0]}
        py={[0, 0, 0]}
        isModalOpen={creatorCardModal}
        setModalOpen={handleModalClose}
      >
        <StyledModalPreview>
          <CenteredModalContents variant={"bottomContainer"}>
            <ModalClickHandler
              px={[6]}
              py={[6]}
              handleModalClose={handleModalClose}
            >
              <StyledShareModal
                isModalOpen={shareModal}
                setModalOpen={setShareModal}
              >
                <ShareModalContents
                  setModalOpen={setShareModal}
                  card={singleCardData.data}
                />
              </StyledShareModal>
              <StyledDivider mb={0} py={2} />
              <CardDetail
                card={singleCardData.data}
                loading={singleCardData.loading}
                source="page"
                handleToggle={handleCardToggle}
                setModal={setModal}
                setCreatorCardModal={setCreatorCardModal}
                onQuery={onQuery}
                isModal={true}
                setShareModal={setShareModal}
                muted={muted}
                setMuted={setMuted}
                handleModalClose={handleModalClose}
              />
              <CardClips
                cardClips={cardClips.clips}
                clipsLoading={cardClips.loading}
                maxHeight={"100%"}
                maxWidth="400px"
                mutateFollowers={mutateFollowers}
                allstarUser={allstarUser}
                setModal={setModal}
              />
              <StyledFloatContent ml={2} flexDirection="column">
                <StyledCloseButton
                  size="small"
                  classification="round"
                  onClick={handleModalClose}
                />
                {!isMobileApp ? (
                  <></>
                ) : (
                  <StyledShareButton
                    mt={3}
                    size="small"
                    classification="round"
                    onClick={() => {
                      setShareModal(true);
                    }}
                  />
                )}
              </StyledFloatContent>
            </ModalClickHandler>
          </CenteredModalContents>
        </StyledModalPreview>
      </StyledModal>

      <StudioAuthNavActions
        justifyContent="flex-end"
        allstarUser={allstarUser}
        logout={logout}
        isVisible={isSideMenuVisible}
        toggleVisible={openFacetMenu}
        enabledCardsVisible={isEnabledVisible}
        setEnabledCardsVisible={openEnabledCards}
        view={view}
        setView={switchViewTab}
        isMobileApp={isMobileApp}
      />

      <FullWidthWrapper>
        <FacetPanel
          isVisible={isSideMenuVisible}
          toggleVisible={toggleSideMenuVisible}
          clear={clear}
          query={query}
          onQuery={onQueryIntercept}
          facets={cardsData.facets}
          facetLoading={cardsData.loading || facetLoading}
        />
        <MainRail
          query={query}
          onQuery={onQuery}
          creatorCards={cardsData.hits}
          handleCardClick={handleCardClick}
          user={allstarUser}
          cardCount={cardsData.count}
          handleCardToggle={handleCardToggle}
          facetLoading={cardsData.loading || facetLoading}
          setModal={setModal}
          homepage={cardsData.homepage}
          homepageData={cardsData.homepageData}
          banner={banner}
          muted={muted}
          setMuted={setMuted}
          view={view}
          handleToggleAll={handleToggleAll}
          isVisible={isSideMenuVisible}
          toggleVisible={setIsEnabledVisable}
          enabledCardsVisible={isEnabledVisible}
          setEnabledCardsVisible={setIsEnabledVisable}
        />
        <EnabledCardsPanel
          isEnabledVisible={isEnabledVisible}
          setIsEnabledVisable={setIsEnabledVisable}
          onQuery={onQuery}
          handleCardClick={handleCardClick}
          handleToggle={handleCardToggle}
          studioSession={StudioSession}
          remixData={remixData}
          ownerInfo={ownerInfo}
          setModal={setModal}
          postRemix={postRemix}
        />
        {isMobileApp && studioSession.isRemixSession && (
          <RemixHeader
            remixData={remixData}
            ownerInfo={ownerInfo}
            postRemix={postRemix}
            remixedCards={
              studioSession.requestingAPI || studioSession.userActivated
            }
          />
        )}
      </FullWidthWrapper>
    </>
  );
}

const StyledModalPreview = styled(Box)`
  align-content: center;
  min-height: calc(100% - (3rem * 2));
  display: block;
  padding-left: 0px;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overscroll-behavior: contain;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
`;

const StyledFloatContent = styled(Flex)`
  position: absolute;
  right: -50px;
  top: 0px;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    top: 15px;
    right: 25px;
    flex-direction: row-reverse;
    margin-bottom: 10px;
  }
`;
const StyledCloseButton = styled(CloseButton)<any>``;
const StyledModal = styled(Modal)<any>`
  display: block;
  overflow-y: auto;
`;
const StyledShareModal = styled(Modal)<any>``;
const StyledDivider = styled(Divider)<any>`
  display: none;
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    display: flex;
    margin-bottom: 10px;
    margin-top: 40px;
  }
`;
const StyledShareButton = styled(ShareCardButton)<any>`
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    margin-left: 0px;
    margin-top: 0px;
    margin-right: 8px;
  }
`;

const CenteredModalContents = styled(Flex)`
  flex-direction: column;
  position: relative;
  min-height: calc(100% - (3rem * 2));
  margin: 3rem auto;
  border-radius: 20px;
  mix-blend-mode: normal;
  width: 100%;
  border-color: #233438;
  border-style: solid;
  border-width: 1px;
  transform: translateY(0) scale(1);
  transition:
    opacity 0.2s ease,
    transform 0.3s ease,
    -webkit-transform 0.3s ease;
  transition-delay: 0.2s;
  opacity: 1;
  max-width: 70%;
  @media (max-width: ${({ theme }) => theme.breaks.standard}) {
    width: 70%;
    max-width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    width: 100%;
    max-width: 100%;
    overflow: auto;
  }
`;
